import { CheckCircleIcon, WarningCircleIcon } from "@phosphor-icons/react";

const WeekTabLabel = ({ dayName, dateStr, hours }) => {
    const isComplete = hours >= 7;
    return (
        <div
            style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: 4,
            }}
        >
            <span>
                {dayName} {dateStr}
            </span>
            <div
                style={{
                    color: isComplete ? "var(--green-500)" : "var(--yellow-500)",
                    fontWeight: "bold",
                    fontSize: "0.85rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                }}
            >
                {hours} h {isComplete ? <CheckCircleIcon size={16} weight="bold" color="var(--green-500)" /> : <WarningCircleIcon size={16} weight="bold" color="var(--yellow-500)" />}
            </div>
        </div>
    );
};

export default WeekTabLabel;
